<script setup lang="ts">
import { computed } from 'vue'
import { NButton, NDropdown } from 'naive-ui'
import StatusPill from '../StatusPill.vue'
import type { AgentChannelSummary } from '../../stores/agent_channels'

const props = defineProps<{ channel: AgentChannelSummary; showMembersToggle: boolean }>()
const emit = defineEmits<{ rename: []; archive: []; delete: []; members: [] }>()

const options = computed(() => [
  { key: 'rename', label: 'Rename' },
  { key: 'archive', label: props.channel.archived ? 'Unarchive' : 'Archive' },
  { key: 'delete', label: 'Delete…' },
])

function onSelect(key: 'rename' | 'archive' | 'delete'): void {
  if (key === 'rename') emit('rename')
  else if (key === 'archive') emit('archive')
  else emit('delete')
}
</script>

<template>
  <header class="flex items-center justify-between gap-2" data-testid="channel-header">
    <div class="flex items-center gap-2 min-w-0">
      <h1 class="text-xl font-semibold text-white m-0 truncate">#{{ channel.name }}</h1>
      <StatusPill
        v-if="channel.archived"
        label="Archived"
        color-class="bg-amber-400/15 text-amber-300"
        data-testid="archived-pill"
      />
    </div>
    <div class="flex items-center gap-2 shrink-0">
      <NButton v-if="showMembersToggle" size="small" data-testid="members-toggle" @click="emit('members')">
        Members ({{ channel.member_count }})
      </NButton>
      <NDropdown trigger="click" :options="options" @select="onSelect">
        <NButton size="small" aria-label="Channel actions" data-testid="channel-actions">⋯</NButton>
      </NDropdown>
    </div>
  </header>
</template>
